import { gql } from '@anyx/common-graphql';

export const PRODUCT_TAGS_INPUT = gql(/* GraphQL */ `
  query ProductTagsInput($filter: ProductTagsFilterInput) {
    tagsV2(filter: $filter)
  }
`);
